module.exports = __webpack_public_path__ + "img/sph.b84d027d.jpg";